import { baseSelectStyles } from 'js/components/elements/rselect/ReactSelectUtils';

export const selectStyles = {
  ...baseSelectStyles,
  control: (styles: any) => ({
    ...styles,
    minHeight: 38,
    borderRadius: 8,
  }),
  container: (styles: any) => ({
    ...styles,
    width: 165,
    height: 38,
    fontSize: 12,
    marginRight: 8,
  }),
  option: (styles: any) => ({
    ...styles,
    padding: '0 12px',
    fontSize: 12,
    lineHeight: '32px',
  }),
};
